module.exports = __webpack_public_path__ + "media/images/sp/specials/common/special_c_14-e4106046871055b4a97dd542ca1d20cc.jpg";